import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import CategoryManagement from "../CategoryManagement/CategoryManagement";
import SubCategoryManagement from "../SubCategoryManagement/SubCategoryManagement";
import BlogPostList from "../BlogPostList/BlogPostList";
import { blogCategoryServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogCategoryServices";

const BlogPage = () => {
  const [openModule, setOpenModule] = useState("blogPost");
  const [blogCategories, setBlogCategories] = useState([]);

  const getActiveBlogCategoryList = async () => {
    let data = await blogCategoryServices.getBlogCategoryList(
      "active",
    );
    setBlogCategories(data?.data || []);
  };

  useEffect(() => {
    getActiveBlogCategoryList();
    ;
  }, []);
  return (
    <>
      <div className="h-100 d-flex flex-column w-100">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="hstack justify-content-between">
            <div>
              <h6 className="fw-semibold m-0">Blog Post</h6>
              <Form.Text className="text-muted" style={{ fontSize: 13 }}>
                Manage your blogs, news stories, and insights from one powerful workspace.
              </Form.Text>
            </div>

            <div className="hstack gap-2">
              <Button
                variant={
                  openModule === "blogPost" ? "primary" : "outline-primary"
                }
                size="sm"
                onClick={() => setOpenModule("blogPost")}
              >
                Blogs
              </Button>
              <Button
                variant={
                  openModule === "category" ? "primary" : "outline-primary"
                }
                size="sm"
                onClick={() => setOpenModule("category")}
              >
                Category
              </Button>
              <Button
                variant={
                  openModule === "subCategory" ? "primary" : "outline-primary"
                }
                size="sm"
                onClick={() => setOpenModule("subCategory")}
              >
                Sub Category
              </Button>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 overflow-auto bg-light">
          {openModule === "category" && <CategoryManagement getActiveBlogCategoryList={getActiveBlogCategoryList} />}
          {openModule === "subCategory" && <SubCategoryManagement blogCategories={blogCategories} />}
          {openModule === "blogPost" && <BlogPostList blogCategories={blogCategories} />}
        </div>
      </div>
    </>
  );
};

export default BlogPage;
